import React from 'react';
import { connect } from 'react-redux';
import { setStep } from '../duck/activeStep';
import {
  Button,
  Header,
  Icon,
  Segment,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

function Warning(props) {
  return (
    <Segment padded textAlign="center">
      <Icon
        name={props.icon}
        color={props.color}
        size="massive"
      />
      <Header
        size="huge"
        content={props.header}
        subheader={props.subheader}
      />
      {
        props.showButton &&
          <Button
            content="Take me there"
            basic
            onClick={() => props.setStep(props.step)}
          />
      }
      {
        props.children &&
          props.children
      }
    </Segment>
  );
}

const mapDispatchToProps = dispatch => ({
  setStep: step => dispatch(setStep(step))
})

function mapStateToProps(state) {
  return {}
}

export default connect(
  mapDispatchToProps,
  mapDispatchToProps
)(Warning);

Warning.defaultProps = {
  color: 'yellow',
  icon: 'ban',
  header: 'Hold Up!',
  showButton: true,
  step: 'dealer',
  subheader: 'Something is missing',
}

Warning.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string,
  header: PropTypes.string,
  showButton: PropTypes.bool,
  step: PropTypes.string,
  subheader: PropTypes.string,
}
